<template>
    <section class="gh-section  gh-suicide-prevention__facts gh-bg-skyBlue ">
        <div class="container">
            <p class="gh-center gh-lightBlue gh-section-heading">Suicide Facts</p>
            <div class="gh-facts">
                <div class="gh-fact" v-for="fact in $options.facts" :key="fact.title">
                    <p class="gh-center gh-heading gh-bold gh-lightBlue" v-html="fact.title"></p>
                    <p class="gh-center gh-text gh-lightBlue" v-html="fact.content"></p>
                </div>
            </div>
            <p class="gh-center gh-hint">Source: *<a href="//www.samaritans.org/about-samaritans/research-policy/suicide-facts-and-figures/latest-suicide-data/" target="_blank" class="gh-link">Samaritans</a>, **<a href="//www.suicideinfo.ca/how-many-people-are-affected-by-one-suicide" target="_blank" class="gh-link">Centre for Suicide Prevention</a>.</p>
        </div>
    </section>
</template>
<script>
    export default {
        facts: [
            {
                title: '6,221*',
                content: 'In 2020, 6,221 suicide deaths were registered in the UK.'
            },
            {
                title: '3x*',
                content: 'Men are more than 3x more likely to die by suicide than women.  '
            },
            {
                title: '135**',
                content: 'It is estimated that up to 135 may be affected by a single suicide.'
            }
        ]
    }
</script>
<style lang="scss" scoped>
    .gh-facts {
        display: flex;
        flex-flow: row wrap;
        margin: 0 -1rem;
    }

    .gh-fact {
        flex-basis: 33%;
        padding: 0 1rem;
    }
    .gh-text {
        font-size: 1.3rem;
        margin-bottom: 40px;
        line-height: 1.3;
        font-weight: 600;

        @media only screen
        and (min-device-width : 375px)
        and (max-device-width : 812px)
        and (-webkit-device-pixel-ratio : 3)
        and (orientation : portrait) {
            /* iPHONE X */
            margin-bottom: 10px;
        }

        @media
        only screen and (-webkit-min-device-pixel-ratio: 2.0),
        only screen and (   min--moz-device-pixel-ratio: 2.0),
        only screen and (     -o-min-device-pixel-ratio: 2.0/1),
        only screen and (        min-device-pixel-ratio: 2.0),
        only screen and (                min-resolution: 264dpi),
        only screen and (                min-resolution: 2.0dppx) {
            /* Retina styles here */
            margin-bottom: 25px;
        }
    }

    a {
        text-decoration: underline;
    }

    .gh-hint {
        font-weight: 500;
        margin-bottom: -1.4rem;
        color: #374785;
      font-size: 18px;
        a {
        color: #374785;
        font-family: freight-sans-pro,sans-serif;
        }
    }
    .gh-heading {
        font-size: 2.2rem;
        font-family: proxima-nova,sans-serif;
    }

     @media (max-width: 991px) {
        .gh-heading {
            font-size: 2rem;
        }
    }

    @media (max-width: 767px) {
        .gh-hint {
            margin-bottom: 0;
        }

        .gh-fact {
            flex-basis: 50%;
        }
    }

    @media (max-width: 600px) {
        .gh-fact {
            flex-basis: 100%;
        }
    }
</style>

<style lang="scss">
    @media (max-width: 768px) {
        .gh-suicide-prevention__facts {
            br {
                display: none;
            };
        }
    }
</style>
